define("shared/components/shared/wizards/device-setup/step-two", ["exports", "@ember/component", "@ember/object", "@ember/object/computed", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _computed, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <section class="tOB--wizard" ...attributes>
    <div class="tOB--wizard__left">
      <img alt={{t "wizards.device_setup.3_alt"}} class="o--media" src="/assets/images/img--device__setup--2.png" />
      <span class="tOB--wizard__overlayText u--p__t__0 u--p__lr__lg u--text--white u--text--sm u--text--left">
        {{t "wizards.device_setup.3_demo" username=this.currentSocialProfile.displayNickname}}
      </span>
    </div>
    <div class="tOB--wizard__right">
      <h3 class="tOB--wizard__title">
        {{t "wizards.device_setup.title_2"}}
      </h3>
      <p class="u--m__b__lg">
        {{html-safe (t "wizards.device_setup.desc_2")}}
      </p>
      <a class="o--btn o--btn--default o--btn--block" {{on "click" this.testNotification}}>
        {{t "wizards.device_setup.test_notification"}}
      </a>
    </div>
  </section>
  */
  {
    "id": "RI7qgllR",
    "block": "[[[11,\"section\"],[24,0,\"tOB--wizard\"],[17,1],[12],[1,\"\\n  \"],[10,0],[14,0,\"tOB--wizard__left\"],[12],[1,\"\\n    \"],[10,\"img\"],[15,\"alt\",[28,[37,0],[\"wizards.device_setup.3_alt\"],null]],[14,0,\"o--media\"],[14,\"src\",\"/assets/images/img--device__setup--2.png\"],[12],[13],[1,\"\\n    \"],[10,1],[14,0,\"tOB--wizard__overlayText u--p__t__0 u--p__lr__lg u--text--white u--text--sm u--text--left\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"wizards.device_setup.3_demo\"],[[\"username\"],[[30,0,[\"currentSocialProfile\",\"displayNickname\"]]]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"tOB--wizard__right\"],[12],[1,\"\\n    \"],[10,\"h3\"],[14,0,\"tOB--wizard__title\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"wizards.device_setup.title_2\"],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--m__b__lg\"],[12],[1,\"\\n      \"],[1,[28,[35,1],[[28,[37,0],[\"wizards.device_setup.desc_2\"],null]],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[11,3],[24,0,\"o--btn o--btn--default o--btn--block\"],[4,[38,2],[\"click\",[30,0,[\"testNotification\"]]],null],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"wizards.device_setup.test_notification\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"&attrs\"],false,[\"t\",\"html-safe\",\"on\"]]",
    "moduleName": "shared/components/shared/wizards/device-setup/step-two.hbs",
    "isStrictMode": false
  });
  let StepTwoComponent = _exports.default = (_dec = (0, _computed.reads)('auth.currentSocialProfile'), _dec2 = (0, _computed.reads)('auth.devices.firstObject'), (_class = class StepTwoComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "segment", _descriptor4, this);
      _initializerDefineProperty(this, "currentSocialProfile", _descriptor5, this);
      _initializerDefineProperty(this, "firstDevice", _descriptor6, this);
    }
    testNotification() {
      const {
        id,
        industry,
        businessModel
      } = this.currentSocialProfile;
      this.firstDevice.testNotification().then(() => {
        this.alerts.success(this.intl.t('alerts.account.devices.test_notification.success.message'), {
          timeout: 5000,
          title: this.intl.t('alerts.account.devices.test_notification.success.title')
        });
        this.segment.track('tested-mobile-notification-onboarding', {
          profile: id,
          industry,
          bus_model: businessModel
        });
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "currentSocialProfile", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "firstDevice", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "testNotification", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "testNotification"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, StepTwoComponent);
});